export default {
    GiveAwayAPI_URL: 'https://api-loyalty.wfiws-qa.eu-west-1.aws.pmicloud.biz',
    Tools_Env: 'qa',
    SSO_CallbackUrl: 'https://ems-bo.wfiws-qa.eu-west-1.aws.pmicloud.biz/login',
    CognitoCustomDomain: 'https://wfiws-qa-ems.auth.eu-west-1.amazoncognito.com'
}